// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ExecutedBurn } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

export const useExecutedBurns2Step: () => UseQueryResult<
  TemplateContract<ExecutedBurn>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryExecutedBurnsTwoStep', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryExecutedBurnsTwoStep(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};
